module.exports = __webpack_public_path__ + "img/pesquisa-oficial.b00e5f1d.png";